import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getExtraModuleThunk = createAsyncThunk(
  "extra/get",
  async (params) => {
    const { usertype, topicId } = params;
    let response = await api.get(
      "getTchExtraModulesContentsQuiz/" +
      usertype +
        "/" +
        topicId
         );
    return response.data;
  }
);

export const getExtraTopicThunk = createAsyncThunk(
  "extra/getAllTchExtraModulesTopics",
  async (usertype) => {
    let response = await api.get("getAllTchExtraModulesTopics/" + usertype + "/" + "od");
    return response.data;
  }
);

export const createExtraModuleThunk = createAsyncThunk(
  "extra/create",
  async (body) => {
    let response = await api.put("updateTchExtraModulesContentAssignmentData", body);
    return response.data;
  }
);

export const updateExtraModuleThunk = createAsyncThunk(
  "extra/update",
  async (reqbody) => {
    const topicId = reqbody._id;
    const { _id, ...body } = reqbody; // remove _id from reqbody and create new object called body
    let response = await api.put("updateTchExtraModulesContentAssignmentData" , body);
    return response.data;
  }
);

export const deleteExtraModuleThunk = async(data) =>
await api.put(`updateTchExtraModulesContentAssignmentData`,data);


